import { format } from 'date-fns';
import { Badge } from '@/components/ui/badge';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import type { InvoiceSummary } from '../types';

interface InvoicesTableProps {
  invoices: InvoiceSummary[];
  isLoading: boolean;
}

export function InvoicesTable({ invoices, isLoading }: InvoicesTableProps) {
  if (isLoading) {
    return (
      <div className="border rounded-lg p-8 text-center text-muted-foreground">
        Loading invoices...
      </div>
    );
  }

  if (invoices.length === 0) {
    return (
      <div className="border rounded-lg p-8 text-center text-muted-foreground">
        No invoices found
      </div>
    );
  }

  return (
    <div className="border rounded-lg overflow-hidden">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Invoice</TableHead>
            <TableHead className="text-right">Subtotal</TableHead>
            <TableHead className="text-right">Taxes</TableHead>
            <TableHead className="text-right">Total</TableHead>
            <TableHead className="text-right">Balance</TableHead>
            <TableHead>Status</TableHead>
            <TableHead>Invoice Date</TableHead>
            <TableHead>Due Date</TableHead>
            <TableHead>Payment</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {invoices.map((inv) => {
            const isPaid = inv.balance === 0;
            return (
              <TableRow key={inv.number}>
                <TableCell className="font-mono text-sm">{inv.number}</TableCell>
                <TableCell className="text-right text-sm">${inv.amountSubTotal.toFixed(2)}</TableCell>
                <TableCell className="text-right text-sm">${inv.amountTaxes.toFixed(2)}</TableCell>
                <TableCell className="text-right text-sm font-medium">${inv.amount.toFixed(2)}</TableCell>
                <TableCell className="text-right text-sm">${inv.balance.toFixed(2)}</TableCell>
                <TableCell>
                  <Badge className={isPaid ? 'bg-green-100 text-green-800' : 'bg-amber-100 text-amber-800'}>
                    {isPaid ? 'PAID' : 'UNPAID'}
                  </Badge>
                </TableCell>
                <TableCell className="text-sm">{format(new Date(inv.invoiceDate), 'yyyy-MM-dd')}</TableCell>
                <TableCell className="text-sm">{format(new Date(inv.invoiceDueDate), 'yyyy-MM-dd')}</TableCell>
                <TableCell className="text-sm text-muted-foreground">{inv.paymentTypeCode}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
}
